import { Component, OnInit, Inject, OnDestroy, ViewChild, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatTabGroup, MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/_services/main.service';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-playerinfobox',
  templateUrl: './playerinfobox.component.html',
  styleUrls: ['./playerinfobox.component.scss']
})
export class PlayerinfoboxComponent implements OnInit, OnDestroy {
  @Input() selectedIndex: number | null;
  parameters: any;
  sub_PlayerData: Subscription;
  sub_draft_turn: Subscription;
  subpickerTime: Subscription;
  sub_init_data: Subscription;
  subDraftButton: Subscription;
  sub_current_pick_number: Subscription;
  sub_players_list: Subscription;
  sub_league_draft: Subscription;
  sub_game_position_filers: Subscription;
  subdraftActiveEmit: Subscription;
  subdraftActiveOn: Subscription;
  sub_isMobileScreen: Subscription;
  sub_positionsRemoved: Subscription; 
  currentUser: any;
  loginUserID: number;
  summaryInfo: any;
  assetUploadURL: string;
  noOfRecord = 0;
  picker_id = 0;
  playerDetail: any;
  p_loc: string;
  is_draft_enable = false;
  activeTab = 0;
  newsInfo: any = [];
  gameLogInfo: any = [];
  careerStatsInfo: any = [];
  prePlayer = 0;
  nextPlayer = 0;
  userDraftTurn = 0;
  current_pick_number = 0;
  draftSelectBox: any;
  selected: string;
  isMobile = false;
  storePlayerList:any;
  rosterPositionData:any;
  leagueRecord:any; 
  showDraftBox = false;
  isAutoDraft = false;
  positionRemoved: any = [];

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  constructor(private _mainService: MainService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) private data, private _resultBoardService: ResultboardService, public dialog: MatDialog,
    private spinner: NgxSpinnerService) {
    //this.isMobile = this.deviceService.isMobile();
			if(this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
			this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
			  if (state.length > 0) { 
				this.isMobile = state[0];
			  } 
			});  
    this.parameters = data;
    if(this.parameters.isAutoDraft){
      this.isAutoDraft = this.parameters.isAutoDraft;
    }
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.loginUserID = this.currentUser.id;
    }
    this.assetUploadURL = `${environment.assetUploadURL}`;
    this.getPlayerInfo('summary'); 
    this.draftActiveOn();
    this.draftActiveEmit();
    this.nextPlayer = this.parameters.nextPlayer;
    this.prePlayer = this.parameters.prePlayer; 
    if (this.parameters.draftSelectBox) { 
      this.draftSelectBox = this.parameters.draftSelectBox;
      this.selected = (this.draftSelectBox && this.draftSelectBox.length > 0) ? this.draftSelectBox[0].key : '';
    }
    this.getUserDraftTurn(); 
  }

  changeTab(val) {
    this.tabGroup.selectedIndex = val;
  }

  changeTabData(val) {
    if (val === 1) {
      if (this.gameLogInfo.length === 0) {
        this.getPlayerInfo('game_log');
      }
    } else if (val === 2) {
      if (this.careerStatsInfo.length === 0) {
        this.getPlayerInfo('career_stats');
      }
    } else if (val === 3) {
      if (this.newsInfo.length === 0) {
        this.getPlayerInfo('news');
      }
    }
  }

  getPlayerInfo(tab_name) { 
    if (this.parameters.player_id && this.parameters.season_id  /* && this.parameters.league_id && this.parameters.league_team_id  */&& this.parameters.abbr) {
      this.sub_PlayerData = this._mainService.getPlayerInfoData(this.parameters.player_id, this.parameters.season_id, this.parameters.league_id,
        this.parameters.league_team_id, this.parameters.abbr, this.parameters.draft_status, tab_name).subscribe(res => {  
          if (res.status === 'success') {
            if (tab_name === 'summary') {
              if (res.entities) {
                this.playerDetail = res.entities.playerDetail;
                this.summaryInfo = res.entities;
                if (res.entities.nextGameData && res.entities.nextGameData.player_location === 'home') {
                  this.p_loc = 'vs ';
                } else {
                  this.p_loc = '@';
                }
                if(this.playerDetail.bye_week > 0){
                  this.summaryInfo.p_team += " (Bye: "+this.playerDetail.bye_week+")";
                }
                // for draft btn enable or not
                if ((typeof this.parameters.league_team_id !== 'undefined') && (this.parameters.league_team_id === this.picker_id) &&
                  (this.parameters.draft_status === 'pending') && ((typeof this.parameters.auto_pause !== 'undefined' && this.parameters.auto_pause == 1))) {
                  this.is_draft_enable = true;
                }
                this.getPreAndNextPlayer(this.parameters.player_id);
              }
            } else if (tab_name === 'news') {
              this.newsInfo = res.entities.news;
            } else if (tab_name === 'game_log') {
              this.gameLogInfo = res.entities;
            } else if (tab_name === 'career_stats') {
              this.careerStatsInfo = res.entities;
            }
          }
          this.spinner.hide();   
        })
    }
  }

  getUserDraftTurn() {
    this.sub_draft_turn = this.store.select('draft_turn').subscribe(state => {
      if (state.length > 0) {
        this.userDraftTurn = state[0]; 
      }
    });
    this.sub_current_pick_number = this.store.select('current_pick_number').subscribe(state => {
      if (state.length > 0) {
        this.current_pick_number = state[0];
      }
    });
    this.sub_players_list = this.store.select('players_list').subscribe(state => {
      if (state.length > 0) {
        this.storePlayerList = state[0];
      }
    });
    this.sub_game_position_filers = this.store.select('game_position_filers').subscribe(state => {
      if (state.length > 0) {
        this.rosterPositionData = state[0]; 
      }
    });
    this.sub_league_draft = this.store.select('league_draft').subscribe(state => {
      if (state.length > 0) {
        this.leagueRecord = state[0];
      }
    });
  }

  ngOnDestroy() {
    if (this.sub_PlayerData) { this.sub_PlayerData.unsubscribe(); }
    if (this.sub_draft_turn) { this.sub_draft_turn.unsubscribe(); }
    if (this.sub_init_data) { this.sub_init_data.unsubscribe(); }
    if (this.subpickerTime) { this.subpickerTime.unsubscribe(); }
    if (this.subDraftButton) { this.subDraftButton.unsubscribe(); }
    if (this.sub_current_pick_number) { this.sub_current_pick_number.unsubscribe(); }
    if (this.sub_players_list) { this.sub_players_list.unsubscribe(); }
    if (this.sub_league_draft) { this.sub_league_draft.unsubscribe(); }
    if(this.sub_game_position_filers) { this.sub_game_position_filers.unsubscribe();} 
    if(this.subdraftActiveEmit) { this.subdraftActiveEmit.unsubscribe();} 
    if(this.subdraftActiveOn) { this.subdraftActiveOn.unsubscribe();} 
    if(this.sub_positionsRemoved) { this.sub_positionsRemoved.unsubscribe(); }
  }

  changePlayerData(player_id) {
    if (player_id) {
      this.showDraftBox = false;
      this.summaryInfo = '';
      this.playerDetail = '';
      this.careerStatsInfo = [];
      this.newsInfo = [];
      this.gameLogInfo = [];
      this.parameters.player_id = player_id; 
      this.draftSelectBox       = [];
      this.getPlayerInfo('summary');
      this.draftActiveEmit();
      this.tabGroup.selectedIndex = 0;
      const data = this.storePlayerList.find(i => i.player_id === player_id);
      
      if(this.rosterPositionData){
        const positions = data.positions;
        let p_position_array = [];
        let p_position = [];
        if (typeof (positions) !== 'undefined' && positions !== '') {
          p_position_array = positions.split(',');
          p_position = positions.split(',');
        }

        
        const draftSelectBox = [];
        let totalFixedPosition = 0;
        let extraPickedPlayer = 0;
        
        this.rosterPositionData.forEach(element => {
          if (element.abbr === 'FLEX') {
            p_position_array.push(element.abbr)
          }
          totalFixedPosition += Number(element.roster_position);
          extraPickedPlayer += (Number(element.selected_player) > Number(element.roster_position))?(Number(element.selected_player) - Number(element.roster_position)):0;
        });
        
        if(p_position_array.length > 0){
          p_position_array.forEach((element,key) => {
            if(this.positionRemoved.indexOf(element) > -1){
              p_position_array.splice(key,1);
            }
          });
        }
        
        if (p_position_array.length > 0 && Number(this.leagueRecord.duration_id) !== 8) {
          this.rosterPositionData.forEach(element => {
            if(element.composed_of != '' && p_position_array.length > 0){
              let composed_of = element.composed_of.split(',');
              p_position_array.forEach((element1,key) => {
                if(composed_of.indexOf(element1) > -1 && ((element.roster_position - element.selected_player) > 0)   && (draftSelectBox.findIndex(x=>x.key == element.abbr) == -1)){
                  draftSelectBox.push({ 'key': element.abbr, 'value': element.display_name });
                }
              });
            }
          });
        }else if(Number(this.leagueRecord.duration_id) === 8){  
          const remainPlayerPcik = Number(this.leagueRecord.total_players) - totalFixedPosition;  
          this.rosterPositionData.forEach(element => {

            if(element.composed_of != '' && p_position_array.length > 0){
              let composed_of = element.composed_of.split(',');
              p_position_array.forEach((element1,key) => {
                if(((composed_of.indexOf(element1)) > -1)  && (draftSelectBox.findIndex(x=>x.key == element.abbr) == -1) && ((remainPlayerPcik > extraPickedPlayer) ||  (element.selected_player < element.roster_position))){
                  draftSelectBox.push({ 'key': element.abbr, 'value': element.display_name });
                }
              });
            }
          }); 
        }

        this.draftSelectBox = draftSelectBox;
        this.selected = (this.draftSelectBox && this.draftSelectBox.length > 0) ? this.draftSelectBox[0].key : '';
        
        let counter = 0;
        if(this.draftSelectBox.length > 0) {
          this.draftSelectBox.forEach((element,key) => {
            if(this.rosterPositionData) {
              this.rosterPositionData.forEach(rec => {
                if ((Number(rec.selected_player) === Number(rec.roster_position)) && (key === rec.abbr)) {
                  counter++;
                }
              });
            }
          });
          
          if(counter === this.draftSelectBox.length){
            this.userDraftTurn  = 0;
          }
        }else if(p_position.length > 0){
          this.userDraftTurn  = 0;
        }else{
          if(this.playerDetail.postionsName) {
            if(this.rosterPositionData) {
              this.rosterPositionData.forEach(rec => {
                if ((Number(rec.selected_player) === Number(rec.roster_position)) && (this.playerDetail.postionsName === rec.abbr)) {
                  counter++;
                }
              });
            }
            if(counter > 0){
              this.userDraftTurn  = 0;
            }
          }
        }
      }
    }
  } 

  draftActiveEmit(){
    this.subdraftActiveEmit = this._resultBoardService.draftActiveEmit(this.parameters.league_id,this.parameters.player_id).subscribe(data => {
    });
  }

  draftActiveOn(){
    this.subdraftActiveOn = this._resultBoardService.draftActiveOn().subscribe(data => {
      const picker_id	=	data.picker_id;
      const player_uuid	=	data.player_uuid;
      const pickTime	=	data.pickTime;
      console.log(this.leagueRecord);
      if(this.leagueRecord && (Number(picker_id) === Number(this.parameters.league_team_id)) && (Number(player_uuid) === Number(this.parameters.player_id)) && this.leagueRecord.draft_status === 'pending' && (this.leagueRecord.is_paused === 'N' || (typeof this.leagueRecord.auto_pause !== 'undefined' && this.leagueRecord.auto_pause == 1)) && (this.leagueRecord.seconds_per_pick)) {
        this.showDraftBox = true;
        setTimeout(() => {
          this.showDraftBox = false;
        },( (this.leagueRecord.seconds_per_pick-pickTime)*1000));
      }
    });
  }

  // click on draft button from player info box
  playerDraft() {
    this.dialog.closeAll();
    const pick_data = {
      'plr_team_id': this.playerDetail.team_id,
      'league_id': this.parameters.league_id,
      'picker_id': this.parameters.league_team_id,
      'player_id': this.parameters.player_id,
      'pick_number': (this.current_pick_number === 0)?1:this.current_pick_number,
      'player_name': this.playerDetail.first_name + ' ' + this.playerDetail.last_name,
      'player_team': this.playerDetail.team_abbr,
      'profile_pic': this.playerDetail.profile_pic,
      'player_position': (this.selected) ? this.selected : this.playerDetail.pn, // or select from draft as box,
      'device': 'web',
      'pickedFrom': 'infobox'
      
    };   
    this.subDraftButton = this._resultBoardService.draftButtonEmit(pick_data).subscribe(data => {
    });
  }

  getPreAndNextPlayer(player_id){
    if(this.storePlayerList && player_id){
      const index = (this.storePlayerList[0].player_id != null)?this.storePlayerList.findIndex(i => i.player_id === player_id):this.storePlayerList.findIndex(i => i.id === player_id);
      const nextPlayer = (this.storePlayerList[index+1] != null && typeof this.storePlayerList[index+1].player_id != "undefined")?this.storePlayerList[index+1].player_id:((this.storePlayerList[index+1] != null && this.storePlayerList[index+1].id != null)?this.storePlayerList[index+1].id:0);
      const prePlayer = (this.storePlayerList[index-1] != null && this.storePlayerList[index-1].player_id != null)?this.storePlayerList[index-1].player_id:((this.storePlayerList[index-1] != null && this.storePlayerList[index-1].id != null)?this.storePlayerList[index-1].id:0);
    
      this.prePlayer = prePlayer;
      this.nextPlayer = nextPlayer; 
    }
  } 

  positionsRemovedList() {
    if(this.sub_positionsRemoved) { this.sub_positionsRemoved.unsubscribe(); }
    this.sub_positionsRemoved = this.store.select('positionsRemoved').subscribe(state => {
      if (state.length > 0) { 
        this.positionRemoved = state[0];   
      }
    });
  }

}
